export default __webpack_public_path__ + "static/def-book-cover1-ec99fc84c2d9dcc8d21f27d7ada17b83.png";